import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import cn from 'classnames';

import If from 'utils/If';
import Button from 'components/UiKit/Button';
import refreshSite from './methods/refreshSite';
import { ReactComponent as SystemCrashIcon } from 'images/ssr-icons/system-crash.svg';

export default function ErrorPage({
  hideHomeButton = false,
  hideRefreshButton = false,
  tabTitle = 'Error | Something went wrong',
  message = 'Something went wrong. Please retry or check your connection.\n If the error persists, please contact support',
  className = '',
  imageContainerClassName = '',
  imageClassName = '',
  testClassName = '',
  buttonClassName = '',
  linkClassName = '',
}) {
  return (
    <div className={cn('ErrorPage', className)}>
      <Helmet>
        <title>{tabTitle}</title>
      </Helmet>
      <div className={cn('ErrorPage__image', imageContainerClassName)}>
        <SystemCrashIcon className={imageClassName} />
      </div>
      <div className={cn('ErrorPage__text', testClassName)}>{message}</div>
      <If test={!hideRefreshButton}>
        <Button onClick={refreshSite} className={buttonClassName}>
          Refresh this page
        </Button>
      </If>
      <If test={!hideHomeButton}>
        <Link to="/" className={cn('ErrorPage__link', linkClassName)}>
          Back To Home
        </Link>
      </If>
    </div>
  );
}
